/**
 * Comparación de versiones del agente («2.10.0» > «2.9.9», no alfabética).
 *
 * Vive aquí porque la usan varios sitios: el panel de actividad decide cuántas
 * líneas de log pedir y la pestaña de AD decide si el agente soporta
 * `ad_refresh`.
 */
export function versionAtLeast(value, minimum) {
  const parse = (raw) =>
    String(raw || '')
      .replace(/^v/i, '')
      .split(/[.\-+]/)
      .map((part) => Number.parseInt(part, 10))
      .filter((n) => Number.isFinite(n));

  const left = parse(value);
  const right = parse(minimum);
  if (!left.length || !right.length) return false;

  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const a = left[i] || 0;
    const b = right[i] || 0;
    if (a !== b) return a > b;
  }
  return true;
}

/**
 * `true` si `current` va por detrás de `latest`.
 *
 * Lo usan la lista y la ficha del equipo para marcar el mismo aviso: si la
 * comparación viviera en cada pantalla, una podría decir «desfasado» y la otra
 * no con los mismos datos.
 */
export function versionIsOlder(current, latest) {
  const parse = (raw) =>
    String(raw || '')
      .replace(/^v/i, '')
      .split(/[^0-9]+/)
      .filter(Boolean)
      .slice(0, 4)
      .map(Number);

  const left = parse(current);
  const right = parse(latest);
  if (!left.length || !right.length) return false;

  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const a = left[i] || 0;
    const b = right[i] || 0;
    if (a !== b) return a < b;
  }
  return false;
}
